export enum ErrorAttribute {
  LeadingToAttempt = 895,
  LeadingToGoal = 896,
}
